// redux

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../config/api";
import config from "../config/config";
import { getCurrentLoggedInSessionTokenWithPromise } from "../config/userPool";

const { GET_SITREP_ENDPOINT } = config.api_endpoint;

const initialState = {
  loading: true,
  sitrep: [],
  error: null,
};

export const fetchALLSitrep = createAsyncThunk(
  "sitrep/fetchALLSitrep",
  async (_, { rejectWithValue }) => {
    try {
      const token = await getCurrentLoggedInSessionTokenWithPromise();
      const results = await api.get(GET_SITREP_ENDPOINT, {}, token);
      console.log(results);
      return {
        sitrep: results.data,
      };
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

const SitrepSlice = createSlice({
  name: "sitrep",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchALLSitrep.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchALLSitrep.fulfilled, (state, action) => {
        console.log(action);
        state.loading = false;
        state.sitrep = action.payload;
      })
      .addCase(fetchALLSitrep.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

const SitrepReducer = SitrepSlice.reducer;
export default SitrepReducer;
